'use strict';

var _getI18n = require('./i18n/get-i18n');

var _getI18n2 = _interopRequireDefault(_getI18n);

var _i18nMocker = require('./i18n/i18n-mocker');

var _i18nMocker2 = _interopRequireDefault(_i18nMocker);

var _useLocalisation = require('./i18n/use-localisation');

var _useLocalisation2 = _interopRequireDefault(_useLocalisation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    getI18N: _getI18n2.default,
    mockI18N: _i18nMocker2.default,
    useLocalisation: _useLocalisation2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/lingui-cdn/lib/index.js
// module id = siuH
// module chunks = 0